
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.455 3.649a2.946 2.946 0 00-2.827-2.116h-.859a2.947 2.947 0 00-2.898 2.414l-1.474 8.027.366-1.25a2.947 2.947 0 012.828-2.12h4.998l2.096.816 2.02-.816h-.589a2.947 2.947 0 01-2.827-2.116l-.834-2.84zM7.847 24.86a2.946 2.946 0 002.831 2.129h1.826a2.946 2.946 0 002.947-2.87l.198-7.741-.416 1.421a2.946 2.946 0 01-2.828 2.119h-5.04l-1.796-.975-1.945.975h.58a2.947 2.947 0 012.83 2.128l.814 2.814h-.001z","fill":"#ABAFB5"}}),_c('path',{attrs:{"d":"M17.5 1.533H7.294c-2.917 0-4.666 3.854-5.833 7.708C.078 13.81-1.73 19.915 3.502 19.915h4.407a2.947 2.947 0 002.836-2.137c1.039-3.644 2.093-7.283 3.163-10.918.537-1.81.983-3.363 1.668-4.33a2.304 2.304 0 011.925-.997z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.5 1.533H7.294c-2.917 0-4.666 3.854-5.833 7.708C.078 13.81-1.73 19.915 3.502 19.915h4.407a2.947 2.947 0 002.836-2.137c1.039-3.644 2.093-7.283 3.163-10.918.537-1.81.983-3.363 1.668-4.33a2.304 2.304 0 011.925-.997zM10.499 26.989h10.208c2.916 0 4.666-3.855 5.833-7.71 1.381-4.568 3.19-10.676-2.042-10.676H20.09a2.947 2.947 0 00-2.835 2.137 1327.03 1327.03 0 01-3.164 10.921c-.536 1.81-.983 3.363-1.667 4.331a2.304 2.304 0 01-1.925.997z","fill":"#fff"}}),_c('path',{attrs:{"d":"M10.499 26.989h10.208c2.916 0 4.666-3.855 5.833-7.71 1.381-4.568 3.19-10.676-2.042-10.676H20.09a2.947 2.947 0 00-2.835 2.137 1327.03 1327.03 0 01-3.164 10.921c-.536 1.81-.983 3.363-1.667 4.331a2.304 2.304 0 01-1.925.997z","fill":"#fff"}})])
          )
        }
      }
    